// Global DOM Components.
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Close } from '@mui/icons-material'
import { Drawer, IconButton, MenuItem } from '@mui/material'

import { getAllFacetsAndSyncURL } from 'store/actions/facets'
import { updateSearchResults } from 'store/actions/search'
import { selectHasExecutePermissions, selectIsLibraryMode } from 'store/selectors/user'
import { setPipelineLoading } from 'store/actions/pipeline'
import { setProfileLoading } from 'store/actions/profile'
import { trackSideMenuPageClick } from 'utils/mixpanel'

function LeftMenu(props) {
  const { showMenu, onCloseIconButtonClick } = props
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)
  const dispatch = useDispatch()
  const hasExecutePermissions = useSelector(selectHasExecutePermissions)
  const isLibraryMode = useSelector(selectIsLibraryMode)

  const handleLanguageSwitch = e => {
    dispatch(setPipelineLoading(true))
    dispatch(setProfileLoading(true))
    dispatch(updateSearchResults([]))

    const [_, params] = location.search.split('?')
    const newLang = i18n.language === 'en' ? 'fr' : 'en'

    // Update localstorage state for new language at next page load
    localStorage.setItem('lang', newLang)

    // refetch facet tree with correct content
    dispatch(getAllFacetsAndSyncURL(params))

    // Reload page to get new language content from the API
    history.go(0)
  }

  const handleClick = page => async e => {
    await trackSideMenuPageClick(page)
  }

  return (
    <div className="Left-menu">
      <Drawer open={showMenu} className="Left-menu__wrapper" onClose={onCloseIconButtonClick}>
        <IconButton onClick={onCloseIconButtonClick}>
          <Close />
        </IconButton>
        {hasExecutePermissions && !isLibraryMode && (
          <a href={t.leftMenu.pipeline_url}>
            <MenuItem onClick={handleClick('pipeline')}>{t.leftMenu.pipeline}</MenuItem>
          </a>
        )}
        <a href={t.leftMenu.funder_url}>
          <MenuItem onClick={handleClick('search')}>{t.leftMenu.funder}</MenuItem>
        </a>
        {hasExecutePermissions && !isLibraryMode && (
          <>
            <a href={t.leftMenu.gift_url}>
              <MenuItem onClick={handleClick('gift')}>{t.leftMenu.gift}</MenuItem>
            </a>
            <a href={t.leftMenu.contact_url}>
              <MenuItem onClick={handleClick('contact')}>{t.leftMenu.contact}</MenuItem>
            </a>
          </>
        )}
        <hr />
        <a href={t.leftMenu.help_center_url} target="_blank">
          <MenuItem target="_blank" onClick={handleClick('help-centre')}>
            {t.leftMenu.help_center}
          </MenuItem>
        </a>
        <a onClick={handleLanguageSwitch}>
          <MenuItem onClick={handleLanguageSwitch}>{t.leftMenu.lang}</MenuItem>
        </a>
        <a href={t.leftMenu.terms_url} target="_blank">
          <MenuItem target="_blank" onClick={handleClick('terms-of-use')}>
            {t.leftMenu.terms}
          </MenuItem>
        </a>
        <a href={t.leftMenu.accessibility_url} target="_blank">
          <MenuItem target="_blank" onClick={handleClick('accessibility-policy')}>
            {t.leftMenu.accessibility}
          </MenuItem>
        </a>
        <hr />
        <a href={t.leftMenu.ic_url} target="_blank">
          <MenuItem target="_blank" onClick={handleClick('imagine-canada')}>
            {t.leftMenu.ic}
          </MenuItem>
        </a>
      </Drawer>
    </div>
  )
}

export default LeftMenu
